import timezones from './timezones.json';

export interface Timezone {
  label: string;
  tzCode: string;
  name: string;
  utc: string;
}

export function timezoneList() {
  return timezones;
}

export function getUserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions()?.timeZone;
}
